document.addEventListener('DOMContentLoaded', function() {
    if (!window.isLoggedIn) {
        const currentUrl = window.location.href;
        localStorage.setItem('lastViewedPage', currentUrl);
    }

    const listaFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];

    // Obtiene todos los botones de favoritos en la página
    const botonesFavoritos = document.querySelectorAll('.btn-favoritos');

    botonesFavoritos.forEach(button => {
        const productId = button.getAttribute('data-product-id');
        const heartEmpty = document.getElementById(`heart-empty-${productId}`);
        const heartFilled = document.getElementById(`heart-filled-${productId}`);

        // Verifica si el producto está en la lista de favoritos
        const esFavorito = listaFavoritos.some(favorito => favorito.id == productId);

        if (esFavorito) {
            heartEmpty.style.display = "none";
            heartFilled.style.display = "inline";
            button.classList.add('added');
        } else {
            heartEmpty.style.display = "inline";
            heartFilled.style.display = "none";
            button.classList.remove('added');
        }

        // Agrega un evento de clic para cambiar el estado del favorito
        button.addEventListener('click', function() {
            toggleFavorito(productId, button.getAttribute('data-product-title'), button.getAttribute('data-product-handle'), button.getAttribute('data-product-image'));
        });
    });

    // Redirigir después del inicio de sesión
    if (window.isLoggedIn) {
        const lastViewedPage = localStorage.getItem('lastViewedPage');
        if (lastViewedPage) {
            window.location.href = lastViewedPage;
            localStorage.removeItem('lastViewedPage'); // Elimina la URL almacenada después de la redirección
        }
    }

    // Agrega el evento de clic para el botón de cierre del popup de favoritos
    document.getElementById('popup-close-btn').addEventListener('click', function() {
        document.getElementById('favoritos-popup').style.display = 'none';
    });
});

function toggleFavorito(productId, productTitle, productHandle, productImage) {
    const heartEmpty = document.getElementById(`heart-empty-${productId}`);
    const heartFilled = document.getElementById(`heart-filled-${productId}`);
    const btnFavoritos = heartEmpty.parentElement;

    // Check if user is logged in
    if (!window.isLoggedIn) {
        mostrarPopupLogin();
        return;
    }

    let favoritos = JSON.parse(localStorage.getItem('favoritos')) || [];

    if (heartEmpty.style.display === "none") {
        // Si el corazón lleno está visible, cambiar a vacío
        heartEmpty.style.display = "inline";
        heartFilled.style.display = "none";
        btnFavoritos.classList.remove('added');
        favoritos = favoritos.filter(favorito => favorito.id != productId);
        mostrarPopup('Eliminado de Favoritos');
    } else {
        // Si el corazón vacío está visible, cambiar a lleno
        heartEmpty.style.display = "none";
        heartFilled.style.display = "inline";
        btnFavoritos.classList.add('added');
        favoritos.push({ id: productId, titulo: productTitle, handle: productHandle, imagen: productImage });
        mostrarPopup('¡Se agregó a tus favoritos!');
    }

    localStorage.setItem('favoritos', JSON.stringify(favoritos));
}

function mostrarPopup(mensaje) {
    const popup = document.getElementById('favoritos-popup');
    const popupMessage = document.getElementById('popup-message');
    popupMessage.innerHTML = mensaje;
    popup.style.display = 'block';
}

function mostrarPopupLogin() {
    const loginPopup = document.getElementById('login-popup');
    loginPopup.style.display = 'block';
    
    const cancelBtn = document.getElementById('login-popup-cancel-btn');
    cancelBtn.onclick = function() {
        loginPopup.style.display = 'none';
    };
    
    const loginBtn = document.getElementById('login-popup-login-btn');
    loginBtn.onclick = function() {
        const currentUrl = window.location.href;
        window.location.href = `/account/login?return_to=${encodeURIComponent(currentUrl)}`;
    };
}
